#overlay,#loading{
  position:fixed;inset:0;display:flex;flex-direction:column;gap:14px;
  align-items:center;justify-content:center;text-align:center;
  background:rgba(14,15,13,.55);backdrop-filter:blur(3px);
  -webkit-backdrop-filter:blur(3px);pointer-events:none;z-index:5;
}
#overlay strong,#loading strong{
  font-family:"Archivo",system-ui,sans-serif;font-weight:800;
  font-size:clamp(1.5rem,4vw,2.3rem);letter-spacing:-.03em;
}
#overlay span,#loading span{font-size:.78rem;letter-spacing:.13em;
  text-transform:uppercase;color:var(--dim)}

#door-hint{left:50%;top:62px;transform:translateX(-50%);z-index:4;
  padding:10px 16px;font-size:.76rem;color:var(--accent);pointer-events:none;white-space:nowrap}
#door-fade{position:fixed;inset:0;background:#151813;opacity:0;pointer-events:none;z-index:20}
